<template>
<div :style="{ height: displayMode ? '100%' : 'auto', width: '100%', marginTop: displayMode ? '0px' : '80px'}">
  <div
    v-if="displayMode"
    class="container-resumo">
    <div class="container-btn">
      <button
        :style="{'background-color': primaryColor}"
        class="btn-reservar"
        @click="iniciarReserva">
        Ver ingressos
      </button>
    </div>
  </div>
  <div
    v-else-if="price"
    class="container-estado">
    <div class="container-total-compra">
      <div>
        <strong :key="currentTotal">
          Subtotal: {{ formatMoney(currentTotal) }}
        </strong>
        <span
          v-if="$props.discountByPaymentMethod && currentTotalDesconto < currentTotal"
          class="text-success">Pagando no {{ discountPaymentMethodsLabel || 'Pix' }}: {{ formatMoney(currentTotalDesconto) }}</span>
      </div>
    </div>
    <div class="container-estado-interno">
      <button
        :style="{
          'background-color': 'white',
          'border': '1px solid ' + primaryColor,
          'color': 'black'
        }"
        class="btn-controll"
        :disabled="submitting"
        @click="voltar">
        <i
          v-if="!submitting"
          class="fa-solid fa-angle-left" />&nbsp;&nbsp;
        Voltar
      </button>
      <button
        :style="{'background-color': primaryColor}"
        class="btn-controll"
        :disabled="!canAdvance || submitting"
        @click="avancar">
        {{ submitting ? 'Aguarde...' : 'Avançar' }}&nbsp;&nbsp;
        <i
          v-if="!submitting"
          class="fa-solid fa-angle-right" />
      </button>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name:'ResumoCompraMobileEvento0',
    props: {
        currentTotal: {
            type: Number,
            default: () => 0,
            required: true
        },
        currentTotalDesconto: {
            type: Number,
            default: () => 0,
            required: true
        },
        preco: {
            type: String,
            default: () => '',
            required: true
        },
        precoOriginal: {
            type: String,
            default: () => '',
            required: true
        },
        precoDesconto: {
            type: String,
            default: () => '',
            required: true
        },
        primaryColor: {
            type: String,
            default: () => '#E88A1D',
            required: true
        },
        displayMode: {
            type: Boolean,
            default: () => false,
            required: true
        },
        canAdvance: {
            type: Boolean,
            default: () => false,
            required: true
        },
        submitting: {
            type: Boolean,
            default: () => false,
            required: true
        },
        menuActive: {
            type: Boolean,
            default: () => false,
            required: true
        },
        moeda: {
            type: String,
            default: () => 'BRL',
            required: true
        },
        precoLabel: {
            type: String,
            default: () => '',
            required: true
        },
        price: {
            type: Boolean,
            default: () => false,
        },
        discountPaymentMethodsLabel: {
            type: String,
            default: '',
        },
        discountByPaymentMethod: {
            type: Boolean,
            default: () => false,
        }
    },
    emits: ['iniciar', 'avancar', 'voltar'],
    computed: {
        precoFormatado() {
            const preco = Number(this.$props.preco);
            if(isNaN(preco)) {
                return this.formatMoney(0);
            }
            return this.formatMoney(preco);
        },
        precoDescontoFormatado() {
            const preco = Number(this.$props.precoDesconto);
            if(isNaN(preco) || preco <= 0) {
                return '';
            }
            return this.formatMoney(preco);
        },
        precoOriginalFormatado() {
            const preco = Number(this.$props.precoOriginal);
            if(isNaN(preco) || preco <= 0) {
                return '';
            }
            return this.formatMoney(preco);
        }
    },
    methods: {
        formatMoney(price) {
            let locale = 'pt-Br';

            if (this.$props.moeda === 'USD') {
                locale = 'en-US';
            }

            if(price <= 0 || price === null) {
                return Number(0.00).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
            }
            return Number(price).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
        },
        iniciarReserva() {
            this.$emit('iniciar');
        },
        avancar() {
            if(this.$props.canAdvance) {
                this.$emit('avancar');
            }
        },
        voltar() {
            this.$emit('voltar');
        }
    }
};
</script>

<style scoped>
.container-resumo {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    width: 100%;
}

.container-precos {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 50%;
    height: 90%;
    line-height: 18px;
}

.container-btn {
    /* width: 40%; */
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.btn-controll {
    padding: 15px;
    border-radius: 6px;
    border: none;
    width: 48%;
    color: white;
    height: calc(100% + 2px);
}
.btn-controll[disabled] {
    background-color: #C0C0C0 !important;
    color: white !important;
    border: 1px solid #C0C0C0 !important;
}

.btn-reservar {
    padding: 15px;
    border-radius: 6px;
    border: none;
    width: 90%;
    color: white;
}

.container-estado {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.container-estado-interno {
    width: 90%;
    height: 80%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.container-total-compra {
    width: 100%;
    height: 0px;
    overflow: visible;
    position: relative;
    top: -60px;
}
.container-total-compra>div {
    width: 100%;
    height: 50px;
    padding-left: 1rem;
    line-height: 17px;
    background-color: #FFF1E1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    border-top: 1px solid #E88A1D;
    border-bottom: 1px solid #E88A1D;
}
</style>
